var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

leica.pi.esm.floatingHeaders = (function() {
	"use strict";
	var fh = {};

	// Cache the $(window) reference for use during scroll events.
	var $window = $( window );

	var stickyNavTop = 0;

	// this is for narrow down the call of list based on specific section id
	// initial set to html till it is assigned a specific section/segment
	var $segment = $('html');

	var colNav = leica.pi.esm.columnNavigator;

	fh.ensureHeadersArePositionedCorrectly = function(eventType, $section) {

		//Return from the method if section is hidden
		if (!$section.is(':visible'))
			return;

		// Top of table section that needs to be fixed when vertically scrolled
		// Contains bulk commands and column navigators
		var $NavRow = $section.find('.navfloat');
		var SectionTop = $NavRow.attr('origtop');
		var IsFloating = ($NavRow.css('position') == 'fixed');

		var ScrollTop = $window.scrollTop();

		var $floatingHeader = $section.find('.tableFloatingHeader_clone'); 		

		// Section to check for the bottom top position 
		var $listFooter = $section.find('.ListFooter');
		var tableBottom = Infinity;
		if ($listFooter.filter('.Paginator')) {
			tableBottom = $listFooter.attr('origtop');

		}

		if ((ScrollTop < tableBottom) && (ScrollTop > SectionTop)) {
			// Section is in view, but its top is above it; Float the headers
			if (IsFloating === false || eventType === 'load') {
				floatHeaders($section, $NavRow, $floatingHeader);
			}
		} else if (IsFloating === true) {
			hideFloatingHeaders($NavRow, $floatingHeader);
		}
	}

	// Float bulktask row and header row.
	function floatHeaders($section, $NavRow, $floatingHeader) {

		var NavTop = fh.detailsHeader.StickyHeaderNavTop();
		var HeaderTop = NavTop + $NavRow.height();

		// For Floating, NavRow is extracted from the inline flow
		$NavRow.css({
			'position': 'fixed',
			'top': NavTop,
			'max-width': $section.width(), 	// Prevent the nav row from overflowing the table when removing from the flow
			'z-index': '101', 				// Prevents the nav row from disappearing when taken out of the DOM's flow layout
			'background-color': 'white'
		});

		// For Floating, floatingHeader is made visible (it's a copy of the inline header)
		// Position, size, and show the floating row.
		$floatingHeader.css({
			'display': '',
			'top': HeaderTop,
			'min-width': 'inherit',
			'max-width': 'inherit',
			'width': $section.find('.divTableWithFloatingHeader').width(),
			'overflow':'hidden',
			'z-index': '101'
		});

		// Since the floating row is taken out of the document's flow, it has no way of knowing what its cells' width
		// should be, so we copy the width of each cell in the inline header row to give it a hint.
		var $inlineHeaderRow = $section.find('.tableFloatingHeaderOriginal');
		$inlineHeaderRow.find('th').each(function (index) {
			var desiredWidth = ($(this).width());
			$floatingHeader.find('th').eq(index).css({
				'min-width': desiredWidth,
				'max-width': desiredWidth,
				'width': desiredWidth
			});
		});

		// Ensure floating header horizontal position is in sync
		var $bar = leica.pi.esm.listScrollbar.getScrollbar($section);
		if ($bar.length)
			scrollHeader($floatingHeader, $bar.scrollLeft());
	}

	function scrollHeader($floatingHeader, horzPos) {
    	$floatingHeader.scrollLeft(horzPos);
	}

	// Hide bulktask row and floating header row.
	function hideFloatingHeaders($NavRow, $floatingHeader) {

		// Place NavRow back inline when not floating
		$NavRow.css({
			'position':'',
			'background-color': ''
		});

		// Hide the floatingHeader row
		$floatingHeader.css({
			'display': 'none'
		});
	}

	fh.scroll = function($section, horzPos) {
		var $floatingHeader = $section.find('tr.tableFloatingHeader');
		scrollHeader($floatingHeader, horzPos);
	}

	/* ================== Listing Module==================*/
	var listHeader = (function() {
		var lh = {};
		function CloneHeader() {
			$segment.find('table.ListTable').filter(function() {
				return ($(this).parents('div.divTableWithFloatingHeader').length < 1) && ($(this).attr('id') !== 'AnnotationLayerTable');

			}).each(function() {
				var $this = $(this);
				// add this check to add divTableWithFloatingHeader only once under ListTable
				if  ($this.attr('class') === 'ListTable') {
					// Clone the table header, leaving it in place to flow with the page, then allow original to float
					// giving it a "sticky" appearance.
					var $inlineHeaderRow = $("tr:first", this);

					// Don't create more floating clones than we need. There's some kind of race condition calling
					// this function more often than needed. TODO: Figure out why...
					if ($inlineHeaderRow.hasClass('tableFloatingHeader_clone')) {
						return;
					}

					// Need to set z-index to set the order over positioned div tags
					// This will fix the issue in FF when the floating row is not nested within parent div
					$this.wrap("<div class=\"divTableWithFloatingHeader\" style=\"z-index:1;position:relative\"></div>");

					var $floatingHeader = $inlineHeaderRow.clone();
					$floatingHeader.attr("id", $inlineHeaderRow.attr('id') + '_clone');
					$floatingHeader.addClass("tableFloatingHeader tableFloatingHeader_clone");

					// Configure the floating header to float. Hide it by default so we don't confuse the users.
					// It needs to be positioned too. We do this in `handleFloatingHeaderOnScroll()` in 12.3.js.
					// TODO: Consider reworking this functionality in a more generic fashion, rather than spreading it across files.
					$floatingHeader.css({
						'position': 'fixed',
						'display': 'none'
					});

					$inlineHeaderRow.before($floatingHeader);
					$inlineHeaderRow.addClass("tableFloatingHeaderOriginal");
				}
			});
		};

		function listLoad($section){
			var $body = $('body');
			if(typeof $section === 'undefined' || !$section.length){
				return;
			}

			// Area for tab changed e.g. specimen tab open
			$body.on('tabChanged', function(event, data){ 
				// update the navfloat offset when we navigating tab
				fh.detailsHeader.UpdateNavFloatOffset();
			});	
		}

		/* ** assign the navfloat and origtop ***/
		lh.NavFloat = function() {
			$segment.find('table.ListHeader').each(function() { 
				var $this = $(this);
				if(typeof $this != 'undefined' && $this.not('.navfloat').length) {
					
					$this.attr("id", $this.attr('id') + '_navfloat');
					$this.addClass('navfloat');
					// Save fixed reference point
					$this.attr('origtop', $this.offset().top);							
				}
			});
			
			fh.detailsHeader.UpdateTableBottomOffset();
		};
		
		// Retain the floating header intact when applying pagination or sort or ajax call 
		lh.retainFloatingHeaderCloneAttr = function($section){
			var $cloneHeaderTrAttr = [];
			var $cloneHeaderThAttr = [];
			var $fixedColumnFirstDiv = [];
			var $cloneHeader = $section.find('.ListTableDiv .tableFloatingHeader');
			
			if($cloneHeader.is(':visible')){				
				// get the properties of clone header element
				$cloneHeaderTrAttr =  $cloneHeader.prop('attributes');		
				
				// get all the th properties of floating header
				$cloneHeader.find('th').each(function(){
					var $this = $(this);
					$cloneHeaderThAttr.push($this.prop('attributes'));
				});
				
				// get the properties of fixed column 
				$fixedColumnFirstDiv = $cloneHeader.find('th.fixed-column div').first().prop('attributes');
				
			}
		}
		
		lh.sectionPositioned = function($section){
			var sectionOffsetTop = $section.offset().top;
			// Substract a static number time being to jump to the specific location 
			$window.scrollTop(sectionOffsetTop-70);
		}
		
		lh.run = function($segment) {
			CloneHeader();
			leica.pi.esm.floatingFooter.CloneFooter($segment);

			lh.NavFloat();
			$segment.find('.ListTableDiv').parent().not('.GrandChildTable,.columnScrolling-loaded').each(function(){					
				var $section = $(this);

				leica.pi.esm.floatingFooter.run($section);

				listLoad($section);
			});
		}	

		return lh;
		
	}());
	fh.listHeader = listHeader;
	
	
	
	/* ============== Details module =================*/
	var detailsHeader = (function(){
		var stickyHeader = '';
		var dh = {};
		
		function StickyHeader(){
			var $body = $('body');
			// Create/add the sticky header div
			stickyHeader = $('<div class="sticky-header"></div>');
			if($body.find('div.sticky-header').length === 0){
				$body.append(stickyHeader);
			}			
		}
		
		// Update the navfloat offset when we have toggle any block
		dh.UpdateNavFloatOffset = function() {
			$('table.ListHeader').each(function() { 
				var $this = $(this);
				// update the origtop for navfloat tag
				// in case one column is part of floating header then do not consider for origtop update
				if(typeof $this !== 'undefined' && $this.hasClass('navfloat') && $this.css('position') !== 'fixed') {
					// Update fixed reference point 
					$this.attr('origtop', $this.offset().top);	
				}
			});
			dh.UpdateTableBottomOffset();
		};
		// Update the ListFooter which has Paginator class to vanish the clone floating header 
		dh.UpdateTableBottomOffset = function() {
			// Default assigning origtop to infinity not 0 to make sure it is not floating from beginning
			var origTop = Infinity;
			$('table.ListFooter').each(function() { 
				var $this = $(this);
				if(typeof $this != 'undefined' && $this.find('div.Paginator').length > 0) {
					// Update the same origtop for both expanding and collapsing floating header when table is empty
					if($this.is(':hidden')){
						origTop = $this.parent().find('table.navfloat').attr('origtop');
					} else {
						// Save fixed reference point table bottom position. 
						// Substract some value to collapse the floating header bit earlier
						origTop = $this.offset().top-160;	
					}
					$this.attr('origtop',origTop);
				}
			});
		}

		// Get the navigation top from the sticky floating header if present
		dh.StickyHeaderNavTop = function() {
			var $body = $('body');
			var stickyHeight = 0;
			if($body.find('div.sticky-header').length){
				stickyHeight = $body.find('div.sticky-header').height();
				if(stickyHeight){
					stickyNavTop = stickyHeight;
				}
			}
			return stickyNavTop;
		}

		dh.run = function() {
			StickyHeader();
		}
		
		return dh;
		
	}());
	fh.detailsHeader = detailsHeader;	
	
	return fh;
}());


